module.exports = __webpack_public_path__ + "static/media/badge-below-avg-chart.92f7a94f.jpg";